import React from 'react'
import { Tooltip, TooltipProps } from '@mui/material'

interface TruncatedTextProps {
  text: string | null | undefined
  maxWidth?: string
  maxLength?: number
  placement?: TooltipProps['placement']
  enterDelay?: number
  enterNextDelay?: number
}

const TruncatedText: React.FC<TruncatedTextProps> = ({ 
  text, 
  maxWidth = '200px', 
  maxLength = 30,
  placement = 'bottom',
  enterDelay = 250,
  enterNextDelay = 250
}) => {
  if (!text) return null
  
  const shouldTruncate = text.length > maxLength
  const displayText = shouldTruncate ? `${text.substring(0, maxLength)}...` : text
  
  if (shouldTruncate) {
    return (
      <Tooltip 
        title={text} 
        placement={placement} 
        enterDelay={enterDelay} 
        enterNextDelay={enterNextDelay} 
        arrow
      >
        <span
          style={{
            display: 'block',
            maxWidth,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'pointer'
          }}
        >
          {displayText}
        </span>
      </Tooltip>
    )
  }
  
  return (
    <span
      style={{
        display: 'block',
        maxWidth,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }}
    >
      {text}
    </span>
  )
}

export default TruncatedText
